import React from "react";
import "./index.scss";
const TechnologyStackindex = ({ TechnologyStackData }) => {
  const techStack = [
    {
      category: "Back-end",
      technologies: [".Net", "Laravel"],
    },
    {
      category: "Front-end",
      technologies: ["HTML", "CSS", "Tailwind", "Angular", "React"],
    },
    {
      category: "Mobile",
      technologies: ["iOS", "Android", "Flutter"],
    },
    {
      category: "CMS",
      technologies: ["Shopify", "Wordpress"],
    },
  ];
  return (
    <section className="technicalStackWe">
      <div className="container">
        <div className="technicalStackWeTitle">
          {TechnologyStackData.title}
          <p>
            We use top-of-the-line tools, cutting-edge technologies, and modern
            approaches to expand and grow your business. Our technical stack for
            delivering exceptional software development projects includes the
            following trusted components.
          </p>
        </div>
        <div className="stack">
          {techStack.map((stackItem, index) => (
            <div className="line" key={index}>
              <button className="theme_btn">
                <span>{stackItem.category}</span>
              </button>
              <div className="parts">
                {stackItem.technologies.map((tech, i) => (
                  <span key={i}>{tech}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologyStackindex;
